var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBrakingScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5483 24.6338C22.2768 24.6338 27.7313 19.3213 27.7313 12.7681C27.7313 6.2148 22.2768 0.902344 15.5483 0.902344C8.81976 0.902344 3.36523 6.2148 3.36523 12.7681C3.36523 19.3213 8.81976 24.6338 15.5483 24.6338Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.956 1.57812C27.7133 3.50348 30.4387 7.74835 30.4387 12.7229C30.4709 18.2831 28.2409 21.3176 25.7012 23.9535",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78138 1.57812C3.77275 3.50348 0.656837 7.74835 0.65762 12.7229C0.620815 18.2831 3.16977 21.3176 6.07191 23.9535",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.194 15.0452C14.194 15.8476 14.8001 16.498 15.5477 16.498C16.2953 16.498 16.9014 15.8476 16.9014 15.0452V5.06808C16.9014 4.26572 16.2953 3.61527 15.5477 3.61527C14.8001 3.61527 14.194 4.26572 14.194 5.06808L14.194 15.0452Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.547 21.9211C16.2946 21.9211 16.9007 21.314 16.9007 20.5651C16.9007 19.8161 16.2946 19.209 15.547 19.209C14.7994 19.209 14.1934 19.8161 14.1934 20.5651C14.1934 21.314 14.7994 21.9211 15.547 21.9211Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBrakingScore);
export default __webpack_public_path__ + "static/media/ic_braking_score.9e9390070f476bc85bc554246b1f61ab.svg";
export { ForwardRef as ReactComponent };